import { createApp } from 'vue'
import FloatingVue from 'floating-vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import '@/styles/application.scss'
import 'floating-vue/dist/style.css'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('app')
  if (el) {
    createApp(App)
      .use(router)
      .use(store)
      .use(i18n)
      .use(FloatingVue, {
        instantMove: true,
        arrowOverflow: false,
        disposeTimeout: 5000000,
      })
      .mount(el)
  }
})
